import { motion } from 'framer-motion';
import { Clock, Shield } from 'lucide-react';

const AdminPending = () => {
  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md text-center"
      >
        <div className="glass rounded-xl p-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-yellow-500/20 mb-6">
            <Clock className="w-8 h-8 text-yellow-400" />
          </div>
          
          <h1 className="font-heading font-bold text-2xl uppercase tracking-wider text-white mb-4">
            En attente d'approbation
          </h1>
          
          <p className="text-gray-400 mb-6">
            Votre compte a bien été créé mais nécessite l'approbation d'un administrateur.
          </p>
          
          <div className="flex items-center justify-center gap-2 text-gray-500 text-sm">
            <Shield className="w-4 h-4" />
            <span>Contactez un administrateur pour obtenir l'accès</span>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminPending;
